<template>
    <vue-recaptcha
        ref="recaptcha"
        :sitekey="sitekey"
        @verify="onVerify"
        @expired="onExpired"
        size="invisible"
    />
</template>
<script src="https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit" async defer></script>
<script>
import VueRecaptcha from "vue-recaptcha";

export default {
    components: { VueRecaptcha },
    data() {
        return {
            sitekey: "6LdAxG8aAAAAANw7v6ahlglK0v__GGkcc_UKeDdN",
        };
    },
    methods: {
        onSubmit() {
            this.$refs.recaptcha.execute();
        },
        onVerify() {
            this.getRecoveryPassword();
            this.resetRecaptcha();
        },
        onExpired() {
            this.resetRecaptcha();
        },
        resetRecaptcha() {
            this.$refs.recaptcha.reset();
        },
    },
    mounted() {},
};
</script>